export class Toggle {
  azureADEnabled: boolean;
  federatedLoginIdEnabled: boolean;
  launcherEnabled: boolean;
  scimEnabled: boolean;
  multicareMobileEnabled: boolean;
}
